import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDataSourceHasFailed } from './use-data-sources'
import {
  useStatLicensedSeatCount,
  useStatLicensedSeatAssigned
} from './use-statistic'

export const setNotifyOnce = () => {
  window.sessionStorage.setItem('Instalink::NofifyOnce', 1)
  window.sessionStorage.setItem('Instalink::NotifyUserLimitReached', 1)
}

function getSeatExceeded (seatCount, seatAssigned) {
  if (!seatCount.data?.value || !seatAssigned.data?.value) {
    return false
  }
  if (seatCount.data?.value === -1) {
    // Unlimited seat
    return false
  }
  if (seatCount.data.value < seatAssigned.data.value) {
    return true
  }
  return false
}

export function useNotifyUserLimitReached () {
  const { t } = useTranslation()
  const seatCount = useStatLicensedSeatCount()
  const seatAssigned = useStatLicensedSeatAssigned()

  const [showOnce] = useState(() => {
    return window.sessionStorage.getItem('Instalink::NotifyUserLimitReached')
  })

  const isLoading = seatCount.isLoading || seatAssigned.isLoading
  const isExceeded = getSeatExceeded(seatCount, seatAssigned)

  useEffect(() => {
    if (!showOnce || isLoading) {
      return
    }
    if (showOnce === '1' && isExceeded === true) {
      const data = {
        detail: {
          action: 'show',
          type: 'error',
          title: t('dashboardPage_notifySeatLimitErrorTitle'),
          message: t('dashboardPage_notifySeatLimitErrorMessage'),
          dismissAfter: 60 * 1000
        }
      }
      const event = new CustomEvent('flash2', data)
      window.sessionStorage.setItem('Instalink::NotifyUserLimitReached', 0)
      document.dispatchEvent(event)
    }
    // eslint-disable-next-line
  }, [showOnce, isLoading, isExceeded])
}

export default function useNotifyOnce () {
  const dsFailed = useDataSourceHasFailed()
  const { t } = useTranslation()

  const [showOnce] = useState(() => {
    return window.sessionStorage.getItem('Instalink::NofifyOnce')
  })

  useEffect(() => {
    if (!showOnce || dsFailed.isLoading) {
      return
    }
    if (showOnce === '1' && dsFailed.data === true) {
      const data = {
        detail: {
          action: 'show',
          type: 'error',
          title: t('dashboardPage_notifyDataSourceErrorTitle'),
          message: t('dashboardPage_notifyDataSourceErrorMessage'),
          dismissAfter: 60 * 1000
        }
      }
      const event = new CustomEvent('flash', data)
      window.sessionStorage.setItem('Instalink::NofifyOnce', 0)
      document.dispatchEvent(event)
    }
    // eslint-disable-next-line
  }, [showOnce, dsFailed.data, dsFailed.isLoading])
}
